define(
    'viewmodels/secured/libraries/create',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "viewmodels/secured/explorer/navigation/libraries/libraries",
        "viewmodels/secured/libraries/create/fromScratch/wizard",
        "viewmodels/secured/libraries/create/duplicate/wizard",
        "viewmodels/secured/libraries/create/fromTemplate/wizard",
        "viewmodels/secured/libraries/create/fromFolder/wizard"
    ],
    function (ViewModel, dataProvider, i19n,
        explorerLibraries,
        w_fromScratch,
        w_duplicate,
        w_fromTemplate,
        w_FromFolder
        ){

        var vm = new ViewModel(
        {
            i19n: i19n,

            comboClick: {},

            step1: ko.observable(),
            step2: ko.observable(),
            step3: ko.observable(),
            step4: ko.observable(),

            isValid: ko.observable(false),
            isWait: ko.observable(false),
            
            templates: ko.observableArray([]),
            categories: ko.observableArray([]),

            activeCategory: ko.observable(),
            activeTemplate: ko.observable(),
            activeWizard: ko.observable(),

            wizardModes: ko.observableArray([
                { value: "1", text: i19n.to.createfromscratch, isSelected: ko.observable(false), description: i19n.to.createanewlibraryfromscratch3 },
                { value: "4", text: i19n.to.useablueprint, isSelected: ko.observable(false), description: i19n.to.createanewlibrarybasedononeofthepredefined },
                { value: "2", text: i19n.to.duplicateexisting, isSelected: ko.observable(false), description: i19n.to.duplicateanexistinglibrarytocreateanewemptylibrary2 }                
                //{ value: "3", text: i19n.to.createfromfolder, isSelected: ko.observable(false) }
            ]),
            wizardMode: ko.observable("0"),

            wizardModesClearSelected : function () {
                vm.wizardModes()
                .forEach(function (itm) {
                    itm.isSelected(false);
                });
            },
            templatesClearSelected : function () {
                if (vm.activeCategory() !== undefined && typeof vm.activeCategory().templates() !== undefined) {
                    vm.activeCategory()
                    .templates()
                    .forEach(function (itm) {
                        itm.isSelected(false);
                    });
                }
            },
            categoriesClearSelected : function () {
                vm.categories()
                .forEach(function (itm) {
                    itm.isSelected(false);
                });
            }
        });

        vm.activate = function () {
            vm.isValid(false);
            vm.isWait(true);

            vm.activeWizard(null);
            vm.activeTemplate(null);
            vm.activeCategory(null);

            vm.wizardModesClearSelected();
            //vm.templatesClearSelected();
            //vm.categoriesClearSelected();

            return loadCategories()
            .done(function (categories) {
                vm.categories(categories);

                //vm.activeCategory(vm.categories()[0]);
                //vm.activeCategory().isSelected(true);

                vm.wizardMode("0");
            })
            .fail(function (e) {
                console.error(e);
            });
        };
        vm.attached = function () {
            var wizard = null;

            wizard = $('#fuelux-wizard').ace_wizard()
            .on('change', function (e, info) {
                if (!vm.isValid()) {
                    return false;
                }

                if(info.direction == "next"){
                    if (info.step == 2 && !vm.step2().validate()) return false;
                    if (info.step == 3 && !vm.step3().validate()) return false;
                }

                if (info.step == 3) {
                    vm.isWait(true);

                    setTimeout(function () {
                        vm.isWait(false);
                    }, 2000);
                }

                if (info.step < 4) {
                    var nextText = '<span data-bind="text: ' + i19n.to.next + '"></span><i class="fa fa-arrow-right icon-on-right"></i>';
                    $('.btn.btn-next').html(nextText);
                }                
            })
            .on('finished', function (e) {
                vm.step4()
                .confirm()
                .done(function (result) {

                    if (sessionStorage.getItem("navto") === "explorer") {
                        sessionStorage.setItem("navto", null);                        

                        location.hash = "#explorer";
                    }

                    sessionStorage.setItem("view-library-id", result);

                    //vm.reload(result);
                    //explorerLibraries.loadLibraries();                    

                    location.reload();
                })
                .fail(function (e) {
                    console.error(e);
                }
            );

            }).on('stepclick', function (e) {                
                //return false;//prevent clicking on steps
            });

            //vm.activeWizard(null);
            //vm.isValid(false);

            //setActiveWizard("");
            //vm.categoryClick(vm.categories()[0]);      

            var r = _.debounce(function resizeGrid() {
                var h = $("#library-create-wizard").outerHeight();
                
                //wizard.height(h - 325);
            }, 250);

            $(window).off("resize", r);
            $(window).on("resize", r);

            r();
        };
        vm.wizardClick = function ($wizard) {
            var id = $wizard.value;

            setActiveWizard(id);

            vm.wizardMode(id);            

            vm.wizardModesClearSelected();

            $wizard.isSelected(true);

            vm.isValid(id == "0" || id == "-1" || id == "-2" || id == "-4" ? false : true);
            vm.isWait(id == 4 && vm.activeTemplate() == null);
        };

        vm.categoryClick = function ($category) {
            setActiveWizard(0);

            var id = $category.value;

            vm.activeCategory(_.findWhere(vm.categories(), { value: id }));

            vm.categoriesClearSelected();
            //vm.wizardModesClearSelected();

            vm.wizardMode(id == "1" ? "0" : "-4"); //-4 suspend until template is selected
            vm.isValid(false);

            if (id != "1") {                
                vm.templatesClearSelected();

                vm.activeCategory()
                .loadTemplates()
                .done(function (templates) {
                    var lists = _.sortBy(templates, function (itm) { return itm.sequence; });

                    vm.templates(lists);
                })
                .fail(function (message) {
                    console.error(message);
                });
            } else {
                vm.activeWizard(null);
            }

            $category.isSelected(true);

            vm.activeTemplate(null);
        };
        vm.templateClick = function ($template) {
            var id = $template.value;

            var tmp = _.findWhere(vm.activeCategory().templates(), { value: id });

            setActiveWizard("4", tmp);

            vm.wizardMode("4"); //-4 suspend until template is selected
            vm.isValid(true);
            vm.isWait(false);

            vm.templatesClearSelected();
            
            //tmp.description = "Use this Blueprint to create a {0} Library to hold documents for client entity's. Search by Client or client Entity. Documents can be assigned to a financial year or permanent file. Click Next to Continue.";

            $template.isSelected(true);
            vm.activeTemplate(tmp);
        };

        vm.cancelNoFolderClick = function () {
            vm.wizardModesClearSelected();

            vm.wizardMode('0');
            vm.isValid(false);

            vm.activeWizard(null);
        };

        return vm;

        function setActiveWizard(wizard, data) {
            
            if (wizard == "1") {
                vm.step1(w_fromScratch.step1);
                vm.step2(w_fromScratch.step2);
                vm.step3(w_fromScratch.step3);
                vm.step4(w_fromScratch.step4);

            } else if (wizard == "2") {
                vm.step1(w_duplicate.step1);
                vm.step2(w_duplicate.step2);
                vm.step3(w_duplicate.step3);
                vm.step4(w_duplicate.step4);

            } else if (wizard == "3") {
                vm.step1(w_FromFolder.step1);
                vm.step2(null);
                vm.step3(null);
                vm.step4(null);

            } else if (wizard == "4") {                
                if (data) {
                    //must call activate manually because w_fromTemplate is a standalone model
                    w_fromTemplate.activate(data.text, data.description, data.field, data.list, data.template, data.value, data.defaultName);
                }
                
                vm.step1(w_fromTemplate.step1);
                vm.step2(w_fromTemplate.step2);
                vm.step3(w_fromTemplate.step3);
                vm.step4(w_fromTemplate.step4);
            } else {
                vm.step1(null);
                vm.step2(null);
                vm.step3(null);
                vm.step4(null);
            }
            
            vm.activeWizard(vm.step1());
        }
        function loadCategories() {
            var d = $.Deferred();

            var c_loadDetail = function () {
                var self = this;
                var d = $.Deferred();

                dataProvider.templatelibraries
                .getTemplateDetailById(self.value)
                .done(function (data) {

                    self.description = data.description;
                    self.field = data.fieldsText;
                    self.list = data.listName;
                    self.template = data.folderTemplateDetails;
                    self.defaultName = data.defaultName;

                    d.resolve();

                })
                .fail(function (e) {
                    d.reject('error loading template detail');

                    console.error(e);
                });

                return d.promise();
            };

            var c_loadTemplates = function () {
                var self = this;
                var d = $.Deferred();

                if (self.templates().length == 0) {
                    dataProvider.templatelibraries
                    .getTemplatesByCategoryId(self.value)
                    .done(function (templates) {
                        var detailPromises = [];
                        
                        var lists = _.map(templates, function (itm) {
                            var t = {
                                value: itm.libraryTemplateId,
                                text: itm.name,
                                defaultName: itm.defaultName,
                                description: '',
                                field: '',
                                list: '',
                                template: '',
                                isSelected: ko.observable(false),
                                loadDetail: c_loadDetail,
                                sequence: itm.sequence
                            };

                            detailPromises.push(t.loadDetail());

                            return t;
                        });

                        //lists.push({
                        //    value: '1000',
                        //    text: '1000',
                        //    defaultName: '',
                        //    description: '',
                        //    field: '',
                        //    list: '',
                        //    template: '',
                        //    isSelected: ko.observable(false),
                        //    loadDetail: c_loadDetail,
                        //    sequence: '1000'
                        //});
                        //lists.push({
                        //    value: '10',
                        //    text: '10',
                        //    defaultName: '',
                        //    description: '',
                        //    field: '',
                        //    list: '',
                        //    template: '',
                        //    isSelected: ko.observable(false),
                        //    loadDetail: c_loadDetail,
                        //    sequence: '10'
                        //});
                        //lists.push({
                        //    value: '1010',
                        //    text: '1010',
                        //    defaultName: '',
                        //    description: '',
                        //    field: '',
                        //    list: '',
                        //    template: '',
                        //    isSelected: ko.observable(false),
                        //    loadDetail: c_loadDetail,
                        //    sequence: '1001'
                        //});

                        lists = _.sortBy(lists, function (itm) {
                            
                            try {
                                itm.sequence = itm.sequence == null ? 0 : itm.sequence;
                                itm.sequence = parseInt(itm.sequence);
                            } 
                            catch (ex) {

                            }

                            return itm.sequence;
                        });

                        self.templates(lists);

                        $.when.apply(self, detailPromises).always(function () {
                            d.resolve(self.templates());
                        });

                    })
                    .fail(function (e) {
                        console.warn('error loading template category templates');

                        console.error(e);
                    });
                } else {
                    d.resolve(self.templates());
                }

                return d.promise();
            };

            dataProvider.templatelibraries
            .getCategories()
            .done(function (categories) {
                var lists = _.map(categories, function (itm) {
                    return {
                        value: itm.libraryTemplateCategoryId,
                        text: itm.name,
                        isSelected: ko.observable(false),
                        templates: ko.observableArray([]),
                        loadTemplates: c_loadTemplates,
                        sequence: !itm.sequence ? 0 : itm.sequence
                    };
                });                

                lists = _.sortBy(lists, function (itm) { return itm.sequence; });

                //lists.unshift({ value: "1", text: i19n.to.nocategory, isSelected: ko.observable(true), loadTemplates: function () { }, sequence: "0" });

                d.resolve(lists);
            })
            .fail(function (e) {
                d.reject('error loading template category');

                console.error(e);
            });

            return d.promise();
        }
    }
);;
